/* Harper Kellee — collection page behavior
 * - Tag-filter links (data-hk-filter): AJAX refresh via MDCollection when
 *   available, hard navigation otherwise. Closes the mobile drawer on apply.
 * - Card colorway dots (data-hk-dot): hover/tap swaps the card photo to that
 *   color's image. Event delegation, so AJAX-replaced grids keep working.
 */
(function () {
  'use strict';

  function closeDrawer() {
    var drawer = document.getElementById('md-v2-filter-drawer');
    if (drawer && drawer.classList.contains('open')) {
      drawer.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  function applyDot(dot) {
    var card = dot.closest('.md-v2-pcard');
    if (!card) return;
    var img = dot.getAttribute('data-img');
    var imgEl = card.querySelector('.img');
    if (imgEl && img) {
      imgEl.style.backgroundImage = 'url("' + img + '")';
    }
    var row = dot.closest('.hk-pcard-dots');
    if (row) {
      row.querySelectorAll('[data-hk-dot]').forEach(function (d) { d.classList.remove('is-on'); });
      dot.classList.add('is-on');
    }
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-hk-dot]');
    if (dot) {
      e.preventDefault();
      e.stopPropagation();
      applyDot(dot);
      return;
    }
    var link = e.target.closest('[data-hk-filter]');
    if (link) {
      e.preventDefault();
      var url = link.getAttribute('href');
      closeDrawer();
      if (window.MDCollection && window.MDCollection.refresh) {
        window.MDCollection.refresh(url);
      } else {
        window.location.href = url;
      }
    }
  });

  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest('[data-hk-dot]');
    if (dot) applyDot(dot);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var dot = e.target && e.target.closest ? e.target.closest('[data-hk-dot]') : null;
    if (dot) {
      e.preventDefault();
      applyDot(dot);
    }
  });
})();
